import axios from '../../functions/axios';
import moment from 'moment';
import { useEffect, useState, useMemo } from 'react';
import leftArrow from '../../assets/images/selection_left.png';
import rightArrow from '../../assets/images/selection_right.png';
import editButton from '../../assets/images/editButton.png';
import style from './SoldCarriageList2Print.module.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '../../hooks/useAuthContext';
import { parseDate } from '../../functions/functions';

export default function WeekView() {
  const location = useLocation();
  const [isLoading, setLoading] = useState(true);
  const [apiData, setApiData] = useState([]);
  const initDate = parseDate(Date.parse(location.state?.date || sessionStorage.getItem('selectedWeek') || new Date())).monday;
  const [currentDate, setCurrentDate] = useState(initDate);
  const navigate = useNavigate();
  const { user } = useAuthContext();
  const [searchQueryCarrier, setSearchQueryCarrier] = useState('');

  const filteredData = useMemo(() => {
    return apiData
      .filter((soldCarriage) => {
        if (searchQueryCarrier === '') return true;
        return soldCarriage.carrier.replace(/\s+/g, '').toUpperCase().includes(searchQueryCarrier);
      })

  }, [apiData, searchQueryCarrier]);

  const carrierId = useMemo(() => {
    return [...new Set(filteredData.map((data) => data.carrier))].sort((...args) => {
      const [a, b] = args.map((carrier) => carrier.toUpperCase());
      return a.localeCompare(b, 'pl-PL', { sensitivity: 'base' });
    });
  }, [filteredData]);

  const getCarriageData = async (date = currentDate) => {
    if (!user) return null;
    setLoading(true);
    try {
      const response = await axios.get(`/soldCarriage`, {
        params: {
          startDate: parseDate(date).monday,
          endDate: parseDate(date).sunday,
        },
      });
      setApiData(response.data);
    } catch (error) {
      console.error(error.message);
    }
    setLoading(false);
  };
  useEffect(() => {
    (async () => {
      await getCarriageData();
      window.print();
      navigate('/soldCarriageList');
    })();
  }, [user]);

  const weekDate = ['monday', 'sunday'].map((carriageDayStart) => new Date(parseDate(currentDate)[carriageDayStart]).toLocaleDateString('pl')).join(' - ');

  const navigation = (
    <div className={style.navigation}>
      <p>{weekDate}</p>

      <span className={style.weekNumber}>
        {parseDate(currentDate).week}
      </span>

    </div>
  );

  if (isLoading || !apiData.length) {
    return (
      <>
        {navigation}
        {!apiData.length ? <div className={style.missingData}>Brak danych do wyświetlenia...</div> : null}
      </>
    );
  }


  return (
    <>
      <div className={style.container}>
      <p>Tydzień: {['monday', 'sunday'].map((day) => new Date(parseDate(currentDate)[day]).toLocaleDateString('pl')).join(' - ')}</p>
        <div className={style.mainHeader}>
          <span style={{width: '50px'}}>Przewoźnik </span>
          <span style={{width: '50px'}}>Ładunek od</span>
          <span style={{width: '50px'}}>Trasa z/do</span>
          <span style={{width: '50px'}}>Data załadunku </span>
          <span style={{width: '50px'}}>Data rozładunku</span>
          <span style={{width: '50px'}}>Stawka przewoźnika</span>
          <span style={{width: '50px'}}>Stawka nasza</span>
          <span style={{width: '50px'}}>Nr f-ry przewoźnika</span>
          <span style={{width: '50px'}}>Nr f-ry nasz</span>
          {/* <span>Dokumenty</span> */}
          {/* <span>Status wykonania</span> */}

        </div>
        {carrierId
          .map((carrier) => (
            <div className={style.carWeek} key={carrier}>
              <div className={style.plate}>{carrier.toUpperCase()}</div>
              <div className={style.data}>
                {filteredData
                  .filter((soldCarriage) => soldCarriage.carrier === carrier)
                  .sort((...args) => {
                    const [a, b] = args.map(({ carriageDayStart }) => Date.parse(carriageDayStart));
                    return a - b;
                  })
                  .map((soldCarriage) => {
                    return (
                      <div className={style.carriageData} key={soldCarriage._id}>
                        {/* <div className={style.client}>{soldcarriage.carrier?.split(' ').reduce((acc, element) => [acc, <br />, element]) || '-'}</div> */}
                        <div className={style.driver}>{soldCarriage.contractor || '-'}</div>
                        <div className={style.route}>
                          <ul className={style.routeList}>
                            <li className={style.routeStart}>{soldCarriage.routeStart || '-'}</li>
                            <li className={style.to}>{soldCarriage.routeEnd || '-'}</li>
                          </ul>
                        </div>
                        <div className={style.day}>
                          {new Date(soldCarriage.carriageDayStart).toLocaleDateString('pl')}
                        </div>
                        <div className={style.day}>
                          {new Date(soldCarriage.carriageDayStop).toLocaleDateString('pl')}
                        </div>
                        <div className={style.cost}>
                          {soldCarriage.carrierCost?.toLocaleString('pl-PL', { style: 'currency', currency: soldCarriage.currency || 'EUR' }) || '-'}
                        </div>
                        <div className={style.cost}>
                          {soldCarriage.contractorCost?.toLocaleString('pl-PL', { style: 'currency', currency: soldCarriage.currency || 'EUR' }) || '-'}
                        </div>
                        <div className={style.invoice}>{soldCarriage.carrierInvoice || '-'}</div>
                        <div className={style.invoice}>{soldCarriage.contractorInvoice || '-'}</div>
                        {/* <div className={style.doc}>{<input id='documentation' type='checkbox' name='documentation' checked={soldcarriage.documentation} onChange={() => {}} />}
                        </div> */}
                        <span>
                          <img className={style.editButton} src={editButton} onClick={() => navigate('/editSoldCarriage', { state: soldCarriage })} />
                        </span>
                      </div>
                    );
                  })
                  .reduce((acc, element) => [acc, <hr className={style.dimmed}/>, element])}
              </div>
            </div>
          ))}
      </div>
    </>
  );
}
